import { Component } from '@angular/core';
import { UploadJob, UploadManagerService } from '../../core/upload-manager.service';

@Component({
  standalone: false,
  selector: 'app-upload-status',
  templateUrl: './upload-status.component.html',
  styleUrls: ['./upload-status.component.scss']
})
export class UploadStatusComponent {
  collapsed = false;

  constructor(public uploadMgr: UploadManagerService) {}

  isActive(job: UploadJob): boolean {
    return job.status === 'queued' || job.status === 'uploading' || job.status === 'finalizing';
  }

  isFinished(job: UploadJob): boolean {
    return job.status === 'success' || job.status === 'error';
  }

  activeCount(jobs: UploadJob[]): number {
    return jobs.filter(j => this.isActive(j)).length;
  }

  hasFinished(jobs: UploadJob[]): boolean {
    return jobs.some(j => this.isFinished(j));
  }

  toggle(): void {
    this.collapsed = !this.collapsed;
  }

  statusLabel(job: UploadJob): string {
    switch (job.status) {
      case 'queued': return 'Queued';
      case 'uploading': return `${job.progress}%`;
      case 'finalizing': return 'Finalizing…';
      case 'success': return 'Complete';
      case 'error': return job.errorMessage || 'Failed';
    }
  }
}
